import * as React from 'react';

function Centered(props) {
    const { children, className } = props;
    return (React.createElement("div", { className: `flex flex-col items-center justify-center ${className}`, style: {
            height: "100vh",
            margin: 0,
            backgroundColor: "#f4f7f6",
        } }, children));
}

export { Centered };
//# sourceMappingURL=index.js.map
